import React from "react";
import { Divider, Toolbar, Typography, Box } from "@mui/material";
import DataGridWrapper from "../../../../components/dataGridWrapper/dataGridWrapper";
import { useTranslation } from "react-i18next";
import { CALCULATIONS } from "../../locales/namespaces";
import { muiGridLocales } from "../../../../helpers/muiGridLocales";
import StyledDataGrid from '../styleDataGrid/styleDataGrid'
import ArrowDown2 from "../../../../assets/images/icons/arrowDown2";


const FixedTable = ({ rowsFixed, columns }) => {
    const { t } = useTranslation(CALCULATIONS)
    return (
        <Box className={'customer-index'}>
            <DataGridWrapper
                sx={{
                    height: '424px',
                    "& .MuiDataGrid-columnHeaders":{
                        minHeight: '40px !important',
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                        color: '#8891ac !important',
                        fontWeight: 400,
                        fontSize: '12px!important',
                    },
                    "& svg": {
                        width: '10px'
                    },
                }}
                bold
            >
                <StyledDataGrid
                    getRowClassName={(params) => {
                        if (params.row?.isRepayment === 1) {
                            return 'super-app-theme--1';
                        }
                        return params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
                    }}
                    disableColumnMenu={true} rows={rowsFixed} columns={columns}
                    sx={{
                        ".MuiDataGrid-row:nth-of-type(odd)": {
                            backgroundColor: '#F5F7FC !important'
                        },
                        ".MuiDataGrid-footerContainer": {
                            display: 'none'
                        },
                        ".MuiDataGrid-row:hover": {
                            backgroundColor: '#E6EAF5 !important'
                        },

                        ".MuiDataGrid-row:nth-of-type(even)": {
                            backgroundColor: '#ffffff !important'
                        },
                        ".MuiDataGrid-aggregationColumnHeaderLabel": {
                            display: "none"
                        },
                        '.MuiDataGrid-cell': {
                            fontSize: '14px',
                            fontWeight: '500',
                        },
                        '.MuiDataGrid-cellContent':{
                            fontWeight: '500',
                        },
                        ".MuiDataGrid-row:hover .MuiDataGrid-cell": {
                            fontWeight: 700,
                        },
                        ".MuiDataGrid-row:hover .MuiDataGrid-cellContent": {
                            fontWeight: 700,
                        },
                        "& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer": {
                            visibility: "visible",
                            width: "auto"
                        },
                        "& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon": {
                            opacity: 0.5
                        },
                    }}

                    slots={{
                        columnUnsortedIcon: ArrowDown2,
                    }}
                    localeText={muiGridLocales(t)}
                />
            </DataGridWrapper>
        </Box>
    )
}

export default FixedTable